// extracted by mini-css-extract-plugin
export default {"wheels":"styles_wheels__6ay4I"};